import { Translations } from './types';

export const fr: Translations = {
  sidebar: {
    welcome: 'Bienvenue,',
    logout: 'Déconnexion',
    closeMenu: 'Fermer le menu',
    openMenu: 'Ouvrir le menu',
    menuItems: {
      'Homepage': 'Accueil',
      'Bacheca': 'Tableau',
      'Eventi': 'Événements',
      'Pubblicità': 'Publicité',
      'Invia Messaggi': 'Envoyer des Messages',
      'Clienti': 'Clients',
      'Matching': 'Matching',
      'Location': 'Lieux',
      'Team': 'Équipe',
      'Contabilità': 'Comptabilité',
      'Agenzia Amore': 'Agence Amour',
      'Dating Coach': 'Coach Rencontres',
      'Consulente d\'Immagine': 'Consultant en Image',
      'Messaggeria': 'Messagerie',
      'Tavoli': 'Tables',
      'Messaggi': 'Messages',
      'Consulenze': 'Consultations',
      'Corsi per Single': 'Cours pour Célibataires',
      'Viaggi per Single': 'Voyages pour Célibataires',
      'Marketing': 'Marketing',
      'Altri Eventi': 'Autres Evenements',
      'Speed Date': 'Speed Date',
      'Gestione Staff': 'Gestion du Personnel',
    },
  },
  profile: {
    tabs: {
      profile: 'Profil',
      settings: 'Paramètres',
      company: 'Entreprise',
    },
    header: {
      name: 'Nom',
      role: 'Rôle',
      city: 'Ville',
      notDefined: 'Non définie',
    },
    roles: {
      admin: 'Administrateur',
      organizer: 'Organisateur',
      pr: 'PR',
      collaboratore: 'Collaborateur',
    },
    form: {
      name: 'Nom',
      email: 'Email',
      phone: 'Numéro de Téléphone',
      city: 'Ville',
      emailReadonly: 'L\'email ne peut pas être modifié',
      phonePlaceholder: '+33 1 23 45 67 89',
      cityPlaceholder: 'Entrez la ville',
      changePassword: 'Changer le Mot de Passe',
      newPassword: 'Nouveau Mot de Passe',
      confirmPassword: 'Confirmer le Nouveau Mot de Passe',
      newPasswordPlaceholder: 'Laisser vide pour ne pas modifier',
      confirmPasswordPlaceholder: 'Répéter le nouveau mot de passe',
      saving: 'Enregistrement...',
      save: 'Enregistrer les Modifications',
    },
    settings: {
      notifications: 'Notifications',
      emailNotifications: 'Notifications par Email',
      pushNotifications: 'Notifications Push',
      eventReminders: 'Rappels d\'Événements',
      security: 'Sécurité',
      twoFactor: 'Authentification à Deux Facteurs',
      language: 'Langue',
      languageDescription: 'Sélectionnez la langue de l\'interface d\'administration',
    },
    company: {
      title: 'Profil de l\'Entreprise',
      companyName: 'Nom de l\'Entreprise',
      email: 'Email',
      phone: 'Téléphone',
    },
    messages: {
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
      updateSuccess: 'Profil mis à jour avec succès',
      updateError: 'Erreur lors de la mise à jour du profil',
    },
  },
  homepage: {
    title: 'Accueil',
    loading: 'Chargement...',
    stats: {
      totalEvents: 'Total Événements',
      participants: 'Participants',
      locations: 'Lieux',
      matches: 'Matches',
      totalClients: 'Total Clients',
      totalRevenue: 'Revenus Totaux',
      showRevenue: 'Afficher les revenus',
      hideRevenue: 'Masquer les revenus',
    },
    recentEvents: 'STATISTIQUES DERNIERS ÉVÉNEMENTS',
    upcomingEvents: 'PROCHAINS ÉVÉNEMENTS ITALIE',
    table: {
      eventName: 'Nom de l\'Événement',
      ageRange: 'Tranche d\'Âge',
      date: 'Date',
      location: 'Lieu',
      city: 'Ville',
      participants: 'Participants',
      matches: 'Matches',
      menRevenue: 'Revenus Hommes',
      womenRevenue: 'Revenus Femmes',
      total: 'Total',
      men: 'H: ',
      women: 'F: ',
    },
    noEvents: 'Aucun événement programmé',
    eventStatus: {
      soldOut: 'COMPLET + LISTE D\'ATTENTE',
      almostFull: 'PRESQUE COMPLET',
      limitedSpots: 'PLACES LIMITÉES',
      scheduled: 'PROGRAMMÉ',
    },
  },
  login: {
    brand: 'FlashCrush',
    email: 'Email',
    password: 'Mot de passe',
    loggingIn: 'Connexion en cours...',
    logIn: 'Se Connecter',
    register: 'S\'inscrire',
    forgotPassword: 'Mot de passe oublié ?',
    registrationTitle: 'Inscription',
    registrationDescription: 'Créez un nouveau compte pour participer aux événements.',
    fullName: 'Nom Complet',
    registering: 'Inscription en cours...',
    alreadyHaveAccount: 'Vous avez déjà un compte ? Connectez-vous',
    resetPasswordTitle: 'Récupération du Mot de Passe',
    resetPasswordDescription: 'Entrez votre email pour recevoir les instructions de récupération du mot de passe.',
    sending: 'Envoi en cours...',
    sendInstructions: 'Envoyer les instructions',
    backToLogin: 'Retour à la connexion',
    resetEmailSent: 'Si l\'adresse email existe, vous recevrez les instructions pour réinitialiser votre mot de passe.',
    errors: {
      invalidCredentials: 'Identifiants invalides. Vérifiez votre email et mot de passe et réessayez.',
      emailNotConfirmed: 'Email non confirmé. Vérifiez votre boîte de réception pour le lien de confirmation.',
      invalidEmailFormat: 'Format d\'email invalide. Veuillez entrer une adresse email valide.',
      genericLoginError: 'Une erreur s\'est produite lors de la connexion. Veuillez réessayer plus tard.',
      registrationError: 'Erreur lors de l\'inscription',
      resetPasswordError: 'Erreur lors de la récupération du mot de passe',
    },
  },
  auth: {
    pendingApproval: 'Votre compte est en attente d\'approbation par un administrateur.',
    accountRejected: 'Votre compte a été rejeté. Contactez l\'administrateur pour plus d\'informations.',
    accountSuspended: 'Votre compte a été suspendu. Contactez l\'administrateur pour plus d\'informations.',
    registrationComplete: 'Inscription terminée ! Votre compte est en attente d\'approbation par un administrateur. Vous recevrez une notification lorsque vous pourrez vous connecter.',
  },
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    close: 'Fermer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    search: 'Rechercher',
    noResults: 'Aucun résultat',
    back: 'Retour',
    next: 'Suivant',
    hiddenAmount: '••••• €',
  },
};
